import { render, staticRenderFns } from "./MPListingsComponent.vue?vue&type=template&id=6b08a7b8&scoped=true&"
import script from "./MPListingsComponent.vue?vue&type=script&lang=ts&"
export * from "./MPListingsComponent.vue?vue&type=script&lang=ts&"
import style0 from "./MPListingsComponent.vue?vue&type=style&index=0&id=6b08a7b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b08a7b8",
  null
  
)

export default component.exports